
const init = () => {
  // sumStars - число звезд рейтинга у отзыва
  var sumStars = 5;
  for (var i = 0; i < sumStars; i++ ) {
    
  }

}

export default {
	init
};